/**
 * @name DashboardFunctionsService
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Service para functions relacionadas ao dashboard
 * @package services/supabase/functions
 */

import { PostgrestSingleResponse } from '@supabase/supabase-js';
import { supabase } from '../../../../supabaseConfig';

/**
 * Service para functions de dashboard
 */
export class DashboardFunctionsService {
     
     /**
      * Obtém dados do dashboard para coordenadores
      */
     static async obterDashboardCoordenador(organizacaoId: number): Promise<PostgrestSingleResponse<any>> {
          return supabase
               .rpc('fn_obter_dados_dashboard_coordenador', { id_organizacao: organizacaoId });
     }
     
     /**
      * Obtém dados do dashboard para operadores
      */
     static async obterDashboardOperador(organizacaoId: number): Promise<PostgrestSingleResponse<any>> {
          return supabase
               .rpc('fn_obter_dados_dashboard_operador', { id_organizacao: organizacaoId });
     }

     /**
      * Obtém dados consolidados do dashboard para um responsável
      */
     static async obterDashboardResponsavel(
          idResponsavel: number,
          idOrganizacao: number
     ): Promise<PostgrestSingleResponse<any>> {
          return supabase
               .rpc('fn_obter_dashboard_responsavel', {
                    p_id_responsavel: idResponsavel,
                    p_id_organizacao: idOrganizacao
               });
     }
}

export const dashboardFunctionsService = DashboardFunctionsService;
